import React, { Component } from "react";
import Proptypes from "prop-types";
import Slider from "react-slick";
import { Helmet } from "react-helmet";
import { CardsContainer } from "./style";

class CardCarousel extends Component {
	render() {
		const settings = {
			dots: false,
			infinite: false,
			speed: 500,
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1300,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: false,
						dots: false,
					},
				},
				{
					breakpoint: 760,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: false,
						dots: false,
					},
				},
			],
		};

		return (
			<div>
				<Helmet>
					<link
						rel="stylesheet"
						type="text/css"
						charset="UTF-8"
						href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
					/>
					<link
						rel="stylesheet"
						type="text/css"
						href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
					/>
				</Helmet>
				<CardsContainer>
					<div className="heading">{this.props.heading}</div>
					<div className="content">{this.props.content}</div>
					<Slider {...settings}>
						{this.props.cards.map((card, index) => {
							return (
								<div key={index}>
									<div className="cardWrapper">
										<div className="cardHeading">{card.name}</div>
										<div className="cardContent">{card.detail}</div>
									</div>
								</div>
							);
						})}
					</Slider>
				</CardsContainer>
			</div>
		);
	}
}

CardCarousel.propTypes = {
	heading: Proptypes.string,
	content: Proptypes.string,
	cards: Proptypes.array,
};

CardCarousel.defaultProps = {
	heading: "",
	content: "",
	cards: [],
};

export default CardCarousel;
